import { analyticsTrack, analyticsTrackWithSegments } from "../plugins/segment";
import { isEmpty } from "../utils";

export default {
    data() {
        return {

        }
    },
    methods: {
        fireSegmentTrackingWithSfdcSegments(eventName, sfdcSegments, properties={}) {
            if (!isEmpty(sfdcSegments)) {
                return analyticsTrackWithSegments(eventName, sfdcSegments, properties);
            }
            return analyticsTrack(eventName, properties);
        },
    }
}